import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Paper
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState, useMemo } from "react";
import api from "../../API";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";

interface props {
  sid:any
  c_s?: number;
  c_e?: number;
  className?: string;
}

const EvalTextViewPage = (props: props) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const [evknBackupData, setEvknBackupData] = useState<any>([]);
  const [selectedData, setSelectedData] = useState<any>(null);
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const getEvknBackTextList = async () => {
  
    setBackdrop(true)
    api.get('/getcol1000texts',{params:{email:email, source_id:props.sid}})
    .then((res:any) => {

      const datas = res.data.datas;
      console.log('백업 텍스트', datas)
      
      if(datas && datas.length > 0){
        setEvknBackupData(res.data.datas);
        // 첫 번째 데이터 자동 선택
        setSelectedData(datas[0]);
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }

  useEffect(() => {
    // getJson(props.data);
    getEvknBackTextList()

  }, [props.sid]);

  const handleSelectChange = (event: any) => {
    const selectedId = event.target.value;
    const selectedItem = evknBackupData.find(item => item.document_id === selectedId);
    if (selectedItem) setSelectedData(selectedItem);
  };

  // HTML 이스케이프 (XSS 방지)
  const escapeHtml = (s: string) =>
    s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  // (c_s, c_e) 구간 하이라이트된 HTML (필요 최소만)
  const highlightedHtml = useMemo(() => {
    const text: string = selectedData?.text ?? "";
    if (!text) return "";

    let start = props.c_s ?? -1;
    let end = props.c_e ?? -1;

    if (start < 0 || end < 0 || end <= start || start >= text.length) {
      // 범위가 유효하지 않으면 전체 이스케이프만
      return escapeHtml(text);
    }
    end = Math.min(end, text.length);

    const pre = escapeHtml(text.slice(0, start));
    const mid = escapeHtml(text.slice(start, end));
    const post = escapeHtml(text.slice(end));

    // 스타일을 인라인으로 넣어 CSS 추가 없이 최소 변경
    return `${pre}<span style="background:#fff59d;outline:2px solid #f57c00;border-radius:3px;padding:0 2px;font-weight:700;">${mid}</span>${post}`;
  }, [selectedData?.text, props.c_s, props.c_e]);

  return (
    <Box display="flex">
      <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
        <Box sx={{width:"820px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
          <Box sx={{display:"flex", alignItems:"center"}}>
            <Box sx={{display:"flex", alignItems:"center"}}>
              <Box sx={{marginLeft:"4px"}}>
                <Box display="flex">
                  <Box>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>document_id</Box>
                      <Select id="topic_cd" value={selectedData?.document_id || ""} onChange={handleSelectChange} sx={{backgroundColor: "#fff",color:"green",width:"340px", height: "28px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                      {(evknBackupData && evknBackupData.length > 0) && evknBackupData.map((item:any, index:any) => 
                        <MenuItem key={index} dense value={item.document_id}>{item.idx}({item.document_id})</MenuItem>
                      )}
                      </Select>
                    </Box>
                    <Box display="flex" sx={{marginTop:"8px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류</Box>
                      <Select id="topic_cd" value={selectedData?.category || ""} sx={{backgroundColor: "#fff",color:"green",width:"340px", height: "28px", marginLeft: "54px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={""}>선택하세요</MenuItem>
                        <MenuItem dense value={"101"}>한국형-역사</MenuItem>
                        <MenuItem dense value={"102"}>한국형-문화</MenuItem>
                        <MenuItem dense value={"103"}>한국형-사회</MenuItem>
                        <MenuItem dense value={"104"}>한국형-지리</MenuItem>
                        <MenuItem dense value={"105"}>한국형-언어</MenuItem>
                        <MenuItem dense value={"106"}>한국형-정치및법</MenuItem>
                        <MenuItem dense value={"201"}>글로벌-일반상식</MenuItem>
                        <MenuItem dense value={"202"}>글로벌-과학</MenuItem>
                        <MenuItem dense value={"203"}>글로벌-인문학및사회학</MenuItem>
                        <MenuItem dense value={"204"}>글로벌-공학및기술</MenuItem>
                        <MenuItem dense value={"205"}>글로벌-경제</MenuItem>
                        <MenuItem dense value={"206"}>글로벌-기타</MenuItem>
                      </Select>
                    </Box>
                  </Box>
                  <Box sx={{marginLeft:"16px"}}>
                    <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                    <Box><textarea value={selectedData?.keyword || ""} spellCheck="false" style={{width:"330px",minHeight:"28px", fontSize:"12px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
                <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                <Box><textarea value={selectedData?.title || ""} spellCheck="false" style={{width:"810px",minHeight:"32px", fontSize:"12px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                <Box
                  sx={{
                    width: "800px",
                    minHeight: "600px",
                    maxHeight: "600px",
                    overflow: "auto",
                    fontSize: "15px",
                    fontWeight: 600,
                    p: "8px",
                    bgcolor: "#fff",
                    borderRadius: "4px",
                    border: "2px solid #498ad5",
                    fontFamily: "Noto Sans KR",
                    lineHeight: 1.6,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                  dangerouslySetInnerHTML={{ __html: highlightedHtml }}
                />
                {/* <textarea value={selectedData?.text || ""} spellCheck="false" style={{width:"928px",minHeight:"600px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box> */}

              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default EvalTextViewPage;
